import { z } from 'zod'

import { simulacaoPropostaProdutoSchema } from '@/features/proposta/shared/domain/schemas/simulacao-proposta.schema'

export const simulacaoPropostaBrasilSchema = simulacaoPropostaProdutoSchema.extend({
  cliente: z.object({
    id: z.string(),
    vendedorAlocadoId: z.string().nullish(),
    cpf: z.string().nullish(),
  }),
})

export type TSimulacaoPropostaBrasil = z.input<typeof simulacaoPropostaBrasilSchema>
